import { render, staticRenderFns } from "./UnprocessedDetails.vue?vue&type=template&id=1ef844c6&scoped=true&"
import script from "./UnprocessedDetails.vue?vue&type=script&lang=js&"
export * from "./UnprocessedDetails.vue?vue&type=script&lang=js&"
import style0 from "./UnprocessedDetails.vue?vue&type=style&index=0&id=1ef844c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef844c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VRow})
